// extracted by mini-css-extract-plugin
export default {"wrapper":"modal-header_wrapper__Qk3kB","wrapper_end":"modal-header_wrapper_end__7B1Pn","buttonClose":"modal-header_buttonClose__vNSyi"};